import React from 'react';
import './ProjectItem.css';

import { FaLink, FaPlus } from 'react-icons/fa';
import { Link } from 'react-router-dom';
 


const ProjectItem = (props) => {  
 
  // Destructuring props
  const { id, image, title, category, popup, project, className } = props;
 
  return (
    <div className={`project-item ${className}`} key={id}>

      <div className="projects-content">
  
        {/* Project image */} 
        <img src={image} alt={title} /> 
  
        {/* Project Content */} 
        <div className='content'> 

          <div className='btn-container'>
            {/* Trigger popup function */}
            <a onClick={() => {popup(id)}}><FaPlus className='icon' /></a>  
            {/* Link to the individual Project Page */}
            <Link
              to={{
                pathname: '/Projects/' + title,
              }}
              state={project} >
              <FaLink className='icon' />
            </Link>
          </div>

          <div className='text'>
            {/* Project Category */}
            <p>{category}</p>

            {/* Link to the individual Project Page */}
            <Link
              to={{
                pathname: '/Projects/' + title,
              }}
              state={project} >
              <h3>{title}</h3> {/* Project Title */}
            </Link>
          </div>

        </div>

      </div>

    </div>
  ) 

}

export default ProjectItem;